import { newSize, newVector, fallbackCopy, newTextPinComponent } from '../helpers';
import { newFillInTheBlanksAreaPinComponent } from '../helpers/pin-components/fill-in-the-blanks-area-pin-component';
import { FillInTheBlanksPinLayoutTemplate } from '../models';
import { stringToProsemirror } from '../tip-tap';

export function fillInTheBlanksTitleOnlyLayout({
  question = fallbackCopy['openQuestion.title'],
  backgroundColor,
  backgroundImage,
  htmlContent,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
  htmlContent?: string;
}): FillInTheBlanksPinLayoutTemplate {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(32, 32),
        size: newSize(896, 60),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
        },
      }),
      FILL_IN_THE_BLANKS_AREA: newFillInTheBlanksAreaPinComponent({
        order: 'a1',
        htmlContent,
      }),
    },
    pinComponents: [],
  };
}
